import { postJson } from "@ui/http";

export async function storeExportedContent(exportUrl: string): Promise<{ url: string; h: number }> {
  const { url, h } = await postJson<{ url: string; h: number }>("/app/embed/store_canva_export", { exportUrl });

  return { url, h };
}
